module.exports = __webpack_public_path__ + "media/packs/fonts/UtopiaStd-Bold-e9e067fc659e5bbbfaf1bdfd4fca5fc7.woff2";